// extracted by mini-css-extract-plugin
export default {"main":"ButtonSuspending_main__HP+a1","icon":"ButtonSuspending_icon__LVXj5"};